import link from '../images/link.png';
import wakeclub from '../images/wakeclub.png';
import github from '../images/github.png';

function WakeClubCard() {
  return (
    <div className='w-screen h-96 p-5 flex justify-center items-center lg:mb-48 md:mb-80 flex-col lg:flex-row mb-96'>
      <img src={wakeclub} className='hidden lg:block lg:w-[600px] lg:h-[400px] rounded-xl' />
      <div className='flex-col flex justify-center w-[400px] m-10'>
        <h1 className='font-libreBaskerville text-lg text-center text-blue-900'>WakeClub ⏰</h1>
        <p className='font-raleway text-sm text-center my-3 px-16'>
          WakeClub is an application that incentivises people to develop healthy sleeping habits by letting people earn
          for waking up on time. It's backend is currently being built by me using the .NET framework, with integrations
          with local payments systems and AI image recognition services.
        </p>
        <div className='grid grid-cols-2 font-sans text-sm p-3 text-center font-semibold px-16'>
          <h1 className='mb-1'>.NET</h1>
          <h1 className='mb-1'>AWS</h1>
        </div>
        <div className='flex flex-row justify-evenly px-11'>
          <a
            className='flex flex-row justify-center items-center font-raleway hover:text-slate-500'
            href='https://wakeclub.sg'
            target='_blank'
          >
            <h1 className='hover:underline'>Landing Page</h1>
          </a>
        </div>
      </div>
    </div>
  );
}

export default WakeClubCard;
